/* ============================================================
   VIVĀRA — CLAIMS REGISTER
   ------------------------------------------------------------
   Every wellness, performance, sourcing, extraction and quality
   claim the site could make is registered here with a status.

     status: "approved"  → rendered on the site
     status: "pending"   → NOT rendered; awaiting substantiation

   Nothing with status "pending" reaches the page. To publish a claim,
   supply the substantiation, set status to "approved" and the copy
   appears wherever that key is consumed — no markup changes needed.

   None of this language may state or imply that Element 003 diagnoses,
   treats, cures or prevents any disease.

   SHOPIFY MIGRATION
   -----------------
   This maps to product metafields (namespace `claims`) so legal can
   manage approvals without touching theme code.
   ============================================================ */
(function () {
  "本ポリシーはVIVĀRAで直接ご注文いただいた場合に適用され、お客様の法律上の権利を妨げるものではありません。";

  window.VIVARA_CLAIMS = {
    /* ---- product benefit list (product page) ------------------------
       Approved by the brand owner and supplied as finished artwork
       ("The Benefits of Shilajit", Element 003 product plate).

       Two labels differ from the supplied artwork, on purpose. "Reduces
       stress" and "Improves cognition and memory" assert an outcome, which
       is a disease/treatment register the FDA does not permit for a dietary
       supplement without approval. The wording below keeps the same meaning
       inside structure/function language, which is what a supplement may say
       alongside the FDA disclaimer carried in the footer:

         Reduces stress                 → Supports a calm response to stress
         Improves cognition and memory  → Supports cognitive function and memory

       Everything here still needs substantiation on file before launch —
       correct phrasing is not the same as evidence. */
    benefits: [
      { key: "adaptogenic",   label: "アーユルヴェーダの伝統素材",                              status: "approved" },
      { key: "stress",        label: "落ち着いた毎日のための習慣に",       status: "approved" },
      { key: "energy",        label: "毎日の習慣として",                status: "approved" },
      { key: "detox",         label: "日々のリズムを整える習慣に",                  status: "approved" },
      { key: "fulvic",        label: "フルボ酸と微量ミネラルを豊富に含む",   status: "approved" },
      { key: "cognition",     label: "毎日の実践として",   status: "approved" },
      { key: "cellular",      label: "からだの土台を思う毎日の習慣に",       status: "approved" }
    ],

    /* ---- composition ------------------------------------------------
       "84+ trace minerals" and "most bioavailable" are withdrawn.
       The educational statement below is factual about shilajit as a
       material and makes no claim about Element 003's effects. */
    education: {
      status: "approved",
      text: "シラジットは、天然由来の微量ミネラル、フミン質、" +
            "フルボ酸を幅広く含むミネラル豊富な樹脂です。"
    },

    /* ---- sourcing and process --------------------------------------
       Exact coordinates, altitude band, "cold extracted", "preserves the
       full spectrum" and purification specifics are held until the
       supplier documentation is supplied. */
    sourcing: {
      region:      { status: "approved", label: "地域",  value: "カラコルム山脈" },
      country:     { status: "approved", label: "国", value: "パキスタン北部" },
      harvest:     { status: "approved", label: "採取", value: "高地での野生採取" },
      method:      { status: "approved", label: "手法",  value: "伝統的な知恵と、現代的な手法" },

      coordinates: { status: "pending",  label: "座標", value: null },
      altitude:    { status: "pending",  label: "標高",    value: null },
      extraction:  { status: "pending",  label: "抽出",  value: null },
      purity:      { status: "pending",  label: "純度",      value: null }
    },

    /* ---- testing ----------------------------------------------------
       No badge, seal or testing statement may appear until current
       documentation is on file. */
    testing: {
      thirdParty:          { status: "pending", value: null },
      certificateOfAnalysis: { status: "pending", url: null },
      heavyMetals:         { status: "pending", value: null },
      microbial:           { status: "pending", value: null },
      batchNumber:         { status: "pending", value: null }
    },

    /* Helper: return only approved entries from a list. */
    approved: function (list) {
      return (list || []).filter(function (c) { return c.status === "approved"; });
    },

    /* Helper: is a single claim publishable? */
    ok: function (claim) {
      return !!claim && claim.status === "approved" && claim.value != null;
    }
  };

  /* ---------- rendering ----------
     [data-claims="benefits"] fills with approved benefit claims only.
     With none approved the list — and any element marked
     [data-claims-empty-remove] — is removed rather than left empty. */
  function paint() {
    var C = window.VIVARA_CLAIMS;

    document.querySelectorAll('[data-claims="benefits"]').forEach(function (host) {
      var list = C.approved(C.benefits);
      if (!list.length) {
        document.querySelectorAll("[data-claims-empty-remove]").forEach(function (n) { n.remove(); });
        host.remove();
        return;
      }
      host.innerHTML = "";
      list.forEach(function (c, i) {
        var li = document.createElement("li");
        li.setAttribute("data-reveal", "");
        var n = document.createElement("span");
        n.className = "pp-benefit-n";
        n.textContent = ("0" + (i + 1)).slice(-2);
        var h = document.createElement("h3");
        h.className = "pp-benefit-label";
        h.textContent = c.label;
        li.appendChild(n);
        li.appendChild(h);
        host.appendChild(li);
      });
    });

    /* Sourcing data rows render only where the claim is approved. */
    document.querySelectorAll("[data-claim-sourcing]").forEach(function (el) {
      var claim = C.sourcing[el.getAttribute("data-claim-sourcing")];
      if (!C.ok(claim)) el.remove();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", paint);
  } else {
    paint();
  }
})();
